// Turn react-table's `rows` (already expanded and sorted, i.e. exactly what
// is on screen) into flat CSV records.
export const toExportRows = (tableRows) => (tableRows || []).map(({ original }) => {
  const { subRows, ...record } = original;
  return record;
});

// Every row of the tree regardless of what is expanded, in on-screen sorted
// order. Pass react-table's `preExpandedRows`.
export const toFullTreeExportRows = (tableRows) => (tableRows || []).flatMap((row) => [
  ...toExportRows([row]),
  ...toFullTreeExportRows(row.subRows),
]);
